import { useEffect } from "react";
import { NoDataFound } from "../../../components/table/tableComponent";
import TableSkeleton from "../../../components/skeleton/tableSkeleton";

const ContentCard = ({ title, data = null, loading }) => {
  return (
    <div className="border border-borderColor rounded-md">
      <div className="w-full h-10 flex items-center px-2 bg-light border-0 border-b ">
        <h2 className="text-sm font-bold items-center text-theme">
          {title}
        </h2>
      </div>
      {loading ? (
        <div className="flex flex-col">
          <TableSkeleton colSpan={3} />
        </div>
      ) : data && data.length ? (
        <div className="flex flex-col">
          {data.map((item, index) => {
            return (
              <div
                key={index}
                className={`grid grid-cols-7 items-center border-b border-borderColor
             p-2 last:border-b-0`}
              >
                <span className="col-span-3">{item.label}</span>
                <span className="font-medium col-span-4 truncate">
                  {item.detail}
                </span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col">
          <NoDataFound asTableCell={false} />
        </div>
      )}
    </div>
  );
};

export default ContentCard;
